import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'lrs',
  components: {
    LrsMap: require('./lrsMap.vue').default,
    GoogleMapElementComp: require('../../components/maps/gMapElement.vue').default,
    MapComp: require('../../components/maps/map.vue').default,
  },
  props: {
    dataObj: {
      type: Object,
    },
    /*jobcardId: {
      type: Number,
      required: true
    },
    elementTypeId: {
      type: Number,
      required: true
    },
    elementId: {
      type: Number,
      required: true
    },
    eventId: {
      type: Number,
      required: true
    },
    eventTypeId: {
      type: Number,
      required: true
    },*/
  },
  data: function () {
    return {
      showMapDialog: false,
      showDeleteDialog: false,
      mapProps: {
        jobcardId: 0,
        elementTypeId: 0,
        elementId: 0,
        eventId: 0,
        eventTypeId: 0
      },
      gMapData: {
        elementTypeId: -1,
        elementId: -1,
      },
    }
  },
  created() {
    
  },
  watch: {
    
  },
  methods: {
    deleteLrsEvent() {
      let param = {
        TypeId: this.dataObj.lrsEventTypeId,
        EventId: this.dataObj.lrsEventId
      }

      axios.post('/LrsEvent/Delete', param )
        .then(response => {
          this.setLrsEvent(-1, -1);
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    setLrsEvent(typeId, eventId) {
      const params = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        LrsEventTypeId: typeId,
        LrsEventId: eventId
      };

      axios.post('/OmJobcardActivity/SetLrsEvent', params)
        .then(response => {
          this.showDeleteDialog = false;
          this.$alertMsg(this.$t('lrs.deleteSuccessfully'), 2);

          this.dataObj.lrsEventTypeId = -1;
          this.dataObj.lrsEventId = -1;
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        })
    },
    showMap() {
      this.gMapData.appId = this.dataObj.appId;
      this.gMapData.appKey = this.dataObj.appKey;
      this.gMapData.elementTypeId = this.dataObj.elementTypeId;
      this.gMapData.elementId = this.dataObj.elementId;
      this.gMapData.eventId = this.dataObj.lrsEventId;
      this.gMapData.eventTypeId = this.dataObj.lrsEventTypeId;
      this.gMapData.latitude = null;
      this.gMapData.longitude = null;
      this.gMapData.availableLrsEventTypes = this.dataObj.availableLrsEventTypes;
      this.gMapData.jobcardId = this.dataObj.jobcardId;
      this.showMapDialog = true;
    },
    hideDeleteDialog() {
      this.showDeleteDialog = false;
    },
    refillLrsData(typeId, eventId) {
      this.dataObj.lrsEventId = eventId;
      this.dataObj.lrsEventTypeId = typeId;

      this.showMapDialog = false;
    }
  }
}

